export const iconFontAwesomeDevicesHardwareCameraRetro = (
	<i className="fa-solid fa-camera-retro"></i>
);
